export default "__VITE_ASSET__CuobzF4d__"